const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Obtiene todos los planes de estudio donde aparece una materia.
 * Retorna los programas que la tienen asignada con sus créditos.
 * @param {number|string} id_materia
 */
export async function getPlanesEstudioPorMateria(id_materia) {
  const res = await fetch(
    `${API_BASE}/escolar/planes-estudio/?id_materia=${id_materia}`,
    { headers: getAuthHeaders() }
  );
  if (!res.ok) throw new Error(`GET /planes-estudio/?id_materia=${id_materia} → ${res.status}`);
  const data = await res.json();
  return Array.isArray(data) ? data : (Array.isArray(data.results) ? data.results : []);
}

/**
 * Inserta o actualiza los créditos de una materia en el plan de un programa.
 * Si el par (id_materia, id_programa) ya existe → actualiza creditos_asignados.
 * Si no existe → crea el registro.
 * @param {{ id_materia: number, id_programa: number, creditos_asignados: number }} payload
 */
export async function upsertCreditosPrograma({ id_materia, id_programa, creditos_asignados }) {
  const res = await fetch(`${API_BASE}/escolar/planes-estudio/upsert-creditos/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify({ id_materia, id_programa, creditos_asignados }),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`upsert-creditos ${res.status}: ${text}`);
  }
  return res.json();
}
